<script lang="ts">
    import { ExclamationCircleOutline } from "flowbite-svelte-icons";
    import posthog from "posthog-js";
    import ColoredModal from "../colored/ColoredModal.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";

    let {isOpen = $bindable(), clear, close}: { isOpen: boolean, clear: () => void, close: () => void } = $props();

    function confirmClear() {
        posthog.capture('checklist_cleared');
        clear();
    }

</script>

<ColoredModal autoclose bind:open={isOpen} onclose={close} size="xs">
    <div class="text-center">
        <ExclamationCircleOutline class="mx-auto mb-4 w-12 h-12"/>
        <h3 class="mb-5 text-lg font-normal">Are you sure you want to clear the
            checklist?</h3>
        <ColoredButton class="me-2" color="red" onclick={confirmClear}>Yes, I'm sure</ColoredButton>
        <ColoredButton color="teal">No, cancel</ColoredButton>
    </div>
</ColoredModal>
